import { CoreApiError } from "./api-client";

/** Business refusals the API answers with a code only; keep an operator-readable explanation. */
const CODE_EXPLANATIONS: Record<string, string> = {
  ACTION_STALE: "询单的判断依据已变化，请刷新后按最新判断重新分发。",
  TRIAGE_AGENT_ANALYSIS_PENDING: "AI 辅助判断仍在进行中，请稍候再分发。",
};

/**
 * Operator copy is written in Chinese; internal diagnostics stay in English for the server log, so
 * a non-Chinese reason falls back to the Chinese category text instead of leaking internals.
 */
function operatorFacingReason(error: CoreApiError): string | undefined {
  if (!error.reason) return undefined;
  return /[\u4e00-\u9fff]/.test(error.reason) ? error.reason : undefined;
}

export function describeCoreError(error: unknown): string {
  if (!(error instanceof CoreApiError))
    return "CRM 核心服务暂时不可用，请稍后重试。";
  if (error.code === "STEP_UP_REQUIRED")
    return "需要最近一次高级安全验证；请重新进行本地 UAT 安全登录。";
  if (error.status === 401 || error.code === "SESSION_EXPIRED")
    return "会话已过期，请重新登录。";
  if (error.status >= 500) return "CRM 核心服务暂时不可用。";
  const reason = operatorFacingReason(error);
  if (reason) return reason;
  if (error.code && CODE_EXPLANATIONS[error.code])
    return CODE_EXPLANATIONS[error.code]!;
  if (error.status === 403 || error.code === "PERMISSION_DENIED")
    return "当前工作空间没有执行此操作的权限。";
  if (error.status === 409) return "记录已被其他操作更新，请刷新后重试。";
  return "操作未完成，请检查当前工作空间。";
}

/**
 * Message for a failed operator action: the server's own reason when it has one, the mapped
 * category for code-only refusals, and locally raised validation copy as-is.
 */
export function describeActionError(cause: unknown, fallback: string): string {
  if (cause instanceof CoreApiError) return describeCoreError(cause);
  if (cause instanceof Error && cause.message.trim()) return cause.message;
  return fallback;
}
